import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {labels} from '../../../../../util/utils';
import {generateMessageIcon} from '../../../../../util/svgIcons';

import {clearErrors} from '../../../../../actions/erroractions';
import {setIsModalOpen} from '../../../../../actions/AccessGroups/SetIsModalOpen';

import GMForm from './GMForm';
import ToolbarButton from '../ToolbarButton';

const GenerateMessage = () => {
	const [showModal, setShowModal] = useState(false);

	const dispatch = useDispatch();

	const setModalErrors = (val) => dispatch(clearErrors()).then(() => dispatch(setIsModalOpen(val)));

	const hideModal = (clearErrors) => {
		setShowModal(false);
		clearErrors && setModalErrors(false);
	};

	const renderTrigger = () => {
		const props = {
			onClick: () => {
				setShowModal(true);
				setModalErrors(true);
			},
			svg: generateMessageIcon,
			label: labels.toolbarGenerateMessage
		};

		return <ToolbarButton {...props} />;
	};

	const renderModal = () => {
		const props = {
			showModal,
			hideModal
		};

		return <GMForm {...props} />;
	};

	return (
		<>
			{renderTrigger()}
			{showModal && renderModal()}
		</>
	);
};

export default GenerateMessage;
